import React from "react";
import { Info } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

export const Pricing = () => {
  const { t } = useLanguage();
  return (
    <section
      id="preise"
      className="relative py-20 md:py-32 px-5 md:px-8 lg:px-12 bg-[#0A0D14]"
      data-testid="pricing-section"
    >
      <div className="max-w-5xl mx-auto">
        <div className="mb-12 md:mb-16">
          <p className="font-script text-[#E63946] text-base md:text-xl mb-3">
            — {t.pricing.eyebrow}
          </p>
          <h2
            className="font-heading font-bold uppercase tracking-tight text-3xl sm:text-5xl md:text-6xl text-white mb-4 md:mb-6 leading-[0.95]"
            data-testid="pricing-title"
          >
            {t.pricing.title}
          </h2>
          <p className="text-white/60 text-sm sm:text-base md:text-lg max-w-2xl leading-relaxed">
            {t.pricing.subtitle}
          </p>
        </div>

        <div className="space-y-2 md:space-y-4" data-testid="pricing-list">
          {t.pricing.items.map((item, idx) => (
            <div
              key={idx}
              className="group flex items-end gap-3 md:gap-6 py-3 md:py-4 border-b border-white/5 last:border-b-0 hover:border-white/20 transition-colors"
              data-testid={`pricing-item-${idx}`}
            >
              <span className="font-heading uppercase tracking-wide text-base sm:text-lg md:text-2xl text-white font-medium leading-tight">
                {item.name}
              </span>
              <span className="flex-1 border-b border-dotted border-white/20 mb-1 sm:mb-1.5 group-hover:border-[#E63946]/50 transition-colors" />
              <span className="font-heading text-base sm:text-xl md:text-2xl text-[#E63946] font-bold whitespace-nowrap">
                {item.price}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-10 flex items-start gap-3 p-4 md:p-5 rounded-lg bg-white/[0.02] border border-white/10">
          <Info className="w-5 h-5 text-[#E63946] flex-shrink-0 mt-0.5" />
          <p className="text-xs sm:text-sm text-white/55 leading-relaxed">
            {t.pricing.note}
          </p>
        </div>
      </div>
    </section>
  );
};
